import React from "react";

export const normalizeSectionLabel = (value) => {
  if (typeof value !== "string") return "";
  return value.trim();
};

export const getUniqueSections = (questions = []) => {
  const seen = new Set();
  const sections = [];

  (questions || []).forEach((question) => {
    const section = normalizeSectionLabel(question?.section);
    if (!section) return;
    const key = section.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    sections.push(section);
  });

  return sections;
};

export const SurveySectionLabels = ({
  sections = [],
  activeSection = "",
  className = "",
}) => {
  if (!sections.length) return null;

  const active = normalizeSectionLabel(activeSection).toLowerCase();

  return (
    <div
      className={`mt-3 flex flex-wrap items-center gap-2 ${className}`.trim()}
    >
      {sections.map((section) => {
        const isActive = active && section.toLowerCase() === active;

        return (
          <span
            key={section}
            className={`rounded-full border px-3 py-1 text-sm ${
              isActive
                ? "border-gray-400 bg-gray-300 text-gray-900"
                : "border-gray-200 bg-gray-100 text-gray-700"
            }`}
          >
            {section}
          </span>
        );
      })}
    </div>
  );
};

export default SurveySectionLabels;
